<template>
    <v-layout>
        <v-layout row >
            <v-flex xs12 v-if="!ready" class="text-xs-center mt-5">
              <v-progress-linear :indeterminate="true"></v-progress-linear>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 v-if="ready">
                <v-card>
                <v-layout v-if="error">
                    <app-alert @dismissed="onDismissed" :text="error.message"></app-alert>
                </v-layout>
                    <v-card-text>
                        <v-container>
                            <form @submit.prevent="onSignin">
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                        name="email"
                                        label="Email"
                                        id="email"
                                        v-model="email"
                                        type="email"
                                        required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-text-field
                                        name="password"
                                        label="Password"
                                        id="password"
                                        v-model="password"
                                        type="password"
                                        required>
                                        </v-text-field>
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12>
                                        <v-btn block type="submit" color="primary" :loading="loading">Sign In</v-btn>
                                    </v-flex>
                                </v-layout>
                            </form>
                        </v-container>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-layout>
</template>

<script>
export default {
  data () {
    return {
      email: '',
      password: '',
      ready: false
    }
  },
  created () {
    setTimeout(() => {
      this.ready = true
    }, 2000)
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    loading () {
      return this.$store.getters.loading
    },
    userData () {
      return this.$store.getters.userData.Access.viewAllJobs
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined) {
        const route = this.$route.query
        if (route.returnURL) {
          this.$router.push(route.returnURL)
        } else {
          this.$router.push('/')
        }
      }
    },
    userData (value) {
      if (value === true) {
        const route = this.$route.query
        if (route.returnURL) {
          this.$router.push(route.returnURL)
        } else {
          this.$router.push('/')
        }
      }
    }
  },
  methods: {
    onSignin () {
      this.$store.dispatch('signUserIn', {email: this.email, password: this.password})
    },
    onDismissed () {
      this.$store.dispatch('clearError')
    }
  }
}
</script>



// WEBPACK FOOTER //
// SignIn.vue?435bdfe5